import { render, staticRenderFns } from "./DocumentRecords.vue?vue&type=template&id=4871963d&scoped=true&"
import script from "./DocumentRecords.vue?vue&type=script&lang=js&"
export * from "./DocumentRecords.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRecords.vue?vue&type=style&index=0&id=4871963d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4871963d",
  null
  
)

export default component.exports